__turbopack_context__.v({
  "search-container": "nVQUaW_search-container",
  "search-title": "nVQUaW_search-title",
  "search__loader": "nVQUaW_search__loader",
});
